import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/OptimizedImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailView"] */ "/app/src/components/ProductDetailView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ProductPageGTMReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SeoView"] */ "/app/src/components/seo/SeoView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea"] */ "/app/src/components/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Ratings"] */ "/app/src/components/ui/stars.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabsList","TabsTrigger","TabsContent"] */ "/app/src/components/ui/tabs.tsx");
